import { render, staticRenderFns } from "./NdaSentCell.vue?vue&type=template&id=0a767940&"
import script from "./NdaSentCell.vue?vue&type=script&lang=ts&"
export * from "./NdaSentCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports